import script from "./projectCalendarSideList.vue?vue&type=script&setup=true&lang=js"
export * from "./projectCalendarSideList.vue?vue&type=script&setup=true&lang=js"

import "./projectCalendarSideList.vue?vue&type=style&index=0&id=12ec941c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ec941c"]])

export default __exports__